import imageCompression from 'browser-image-compression';
const ImageCompression = {
  imageCompress: async (data) => {
    let imageFile = null;
    if (data) {
      imageFile = data[0];
    }

    const { width, height } = await getImageDimensions(imageFile);
    console.log(width);
    console.log(height);
    const options = {
      initialQuality: 1,
      useWebWorker: true,
      maxWidthOrHeight: Math.max(width, height),
    };

    console.log(`originalFile size ${imageFile?.size / 1024 / 1024} MB`);
    try {
      const compressedFile = await imageCompression(imageFile, options);
      console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`);

      return compressedFile;
    } catch (error) {
      console.log(error);
    }
  },
};

export default ImageCompression;

const getImageDimensions = (file) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.width, height: img.height });
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
